import metricDefinitions from './metricDefinitions';
import filterDefinitions from './filterDefinitions';
import visualisations from './visualisations';
import savedProgresses from './savedProgresses';
import contentDistributions from './contentDistributions';
import userManagement from './userManagement';
import bonus from './bonus';
import fixedPeriods from './fixedPeriods';
import agentKb from './agentKb';

import getBoardsRef from './getBoardsRef';
import getTimelineEventsRef from './getTimelineEventsRef';
import getDatasetsRef from './getDatasetsRef';
import getReasonCodesRef from './getReasonCodesRef';
import getLegacySavedFiltersRef from './filterDefinitions/getLegacySavedFiltersRef';
import getEntityDefinitionsRef from './getEntityDefinitionsRef';
import getDashboardsRef from './getDashboardsRef';
import getPreviousUploadsRef from './getPreviousUploadsRef';
import getCopyContentReceiptsRef from './getCopyContentReceiptsRef';
import getWorkspacesRef from './getWorkspacesRef';
import getAccountRef from './getAccountRef';
import getUserProfilesRef from './getUserProfilesRef';
import getAccountsRef from './getAccountsRef';
import getTasksRef from './getTasksRef';
import getFmcsaSyncConfigRef from './getFmcsaSyncConfigRef';
import getLabelsRef from './getLabelsRef';
import getChartPalettesRef from './getChartPalettesRef';
import getTextCardContentsRef from './getTextCardContentsRef';
import getMaintenanceModesRef from './getMaintenanceModesRef';
import getFindAndReplaceReceiptsRef from './getFindAndReplaceReceiptsRef';
import getInsightsConversationsRef from './getInsightsConversationsRef';
import getInsightsFeedbackRef from './getInsightsFeedbackRef';
import getInsightsQueryLogRef from './getInsightsQueryLogRef';
import getWallboardHeartbeatsRef from './getWallboardHeartbeatsRef';
const STORE = {
  metricDefinitions,
  filterDefinitions,
  visualisations,
  savedProgresses,
  contentDistributions,
  userManagement,
  bonus,
  fixedPeriods,
  agentKb,
  getFmcsaSyncConfigRef,
  getBoardsRef,
  getTimelineEventsRef,
  getDatasetsRef,
  getReasonCodesRef,
  getLegacySavedFiltersRef,
  getEntityDefinitionsRef,
  getReportsRef: contentDistributions.getReportsRef,
  getWorkspacesRef,
  getDashboardsRef,
  getPreviousUploadsRef,
  getCopyContentReceiptsRef,
  getAccountRef,
  getAccountsRef,
  getUserProfilesRef,
  getTasksRef,
  getLabelsRef,
  getChartPalettesRef,
  getTextCardContentsRef,
  getMaintenanceModesRef,
  getFindAndReplaceReceiptsRef,
  getInsightsConversationsRef,
  getInsightsFeedbackRef,
  getInsightsQueryLogRef,
  getWallboardHeartbeatsRef,
};

export default STORE;
